<template>
  <div class="section section2 bg">
    <h2 class="fs24 fs-rem28 c-black sec-tit">
      <em></em>数字化转型
    </h2>
    <div class="w1200">
      <div class="sec2-list">
        <dl class="list-box">
          <dt class="lst-dt">
            <i class="icon2 icon21"></i>
            <p class="fs18 fs-rem28 dt-tit">新基建区</p>
          </dt>
          <dd class="lst-dd">
            <span class="fs14 fs-rem26 dd-link" @click="$router.push('/service')">智慧应用</span>
            <span class="fs14 fs-rem26 dd-link" @click="$router.push('/service')">可信安全</span>
            <span class="fs14 fs-rem26 dd-link" @click="$router.push('/service')">数据智能</span>
            <span class="fs14 fs-rem26 dd-link" @click="$router.push('/service')">新型网络</span>
            <span class="dd-more more-link" @click="$router.push('/service')">更多</span>
          </dd>
        </dl>
        <dl class="list-box">
          <dt class="lst-dt">
            <i class="icon2 icon22"></i>
            <p class="fs18 fs-rem28 dt-tit">智慧专区</p>
          </dt>
          <dd class="lst-dd">
            <span class="fs14 fs-rem26 dd-link" @click="$router.push('/service')">智慧住建</span>
            <span class="fs14 fs-rem26 dd-link" @click="$router.push('/service')">智慧园区</span>
            <span class="fs14 fs-rem26 dd-link" @click="$router.push('/service')">智慧社区</span>
            <span class="fs14 fs-rem26 dd-link" @click="$router.push('/service')">智慧出行</span>
            <span class="dd-more more-link" @click="$router.push('/service')">更多</span>
          </dd>
        </dl>
        <dl class="list-box">
          <dt class="lst-dt">
            <i class="icon2 icon23"></i>
            <p class="fs18 fs-rem28 dt-tit">智慧应用</p>
          </dt>
          <dd class="lst-dd">
            <span class="fs14 fs-rem26 dd-link" @click="$router.push('/service')">智慧政务</span>
            <span class="fs14 fs-rem26 dd-link" @click="$router.push('/service')">智慧城市</span>
            <span class="fs14 fs-rem26 dd-link" @click="$router.push('/service')">智慧产业</span>
            <span class="fs14 fs-rem26 dd-link" @click="$router.push('/service')">企业赋能</span>
            <span class="dd-more more-link" @click="$router.push('/service')">更多</span>
          </dd>
        </dl>
      </div>
    </div>
  </div>
  <!-- /数字化转型 -->
</template>

<script>
export default {
  name: 'SourceMatch',
  props: {
    msg: String,
  },
};
</script>

<style>
@import url(./Digitization.css);
</style>
